// ########################################################

// // // Request Sub-Contract Payment view styles(validation form)
// ########################################################

import { cardTitle, dangerColor } from 'assets/jss/material-dashboard-pro-react.jsx'
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx'

const requestSubContractPaymentStyle = theme => {
  // console.log(theme)
  return {
    ...customCheckboxRadioSwitch,
    cardTitle: {
      ...cardTitle,
      color: '#FFFFFF'
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: '15px',
      marginBottom: '0px'
    },
    formCategory: {
      marginBottom: '0',
      color: '#999999',
      fontSize: '14px',
      padding: '10px 0 10px'
    },
    center: {
      textAlign: 'center'
    },
    justifyContentCenter: {
      justifyContent: 'center'
    },
    registerButton: {
      float: 'right'
    },
    danger: {
      color: dangerColor + '!important'
    },
    //added for using table layout in requestform
    // anything above is from validation form style
    //tableRoot is for the paper, can't override it's margin
    tableRoot: {
      width: '100%',
      // height: '100px', // no effect
      overflowX: 'auto',
      display: 'table'
      //border: '2px dotted green'
      //didn't see how the below works
      // tableLayout: 'auto',
      // fixedHeader: false

      // @media print {
      //  width:'750px'
      // }
    },
    table: {
      minWidth: 70,
      // width: 'auto',
      // width: '600px',
      // tableLayout: 'auto',
      // fixedHeader: false,
      //border: '1px solid black',
      // cellPadding: '0 !important', // no effect
      // margin: '5px 20px 0px 10px'
      // when not in dashboard
      // margin: '1px 20px',
      // when in dashboard
      margin: '1px 1px',
      'table-layout': 'fixed'
    },

    tableHeader: {
      border: '1px solid black',
      'background-color': '#3399aa',
      fontSize: '16px',
      fontWeight: 'bold',
      height: '55px',
      padding: '0px 10px' // positive
    },
    tableRow: {
      // this is somehow a minHeight from root, can't override it
      height: '5px'
      // hover: true // no effect
    },
    tableCell: {
      border: '1px solid black',
      //minWidth: '1000px',
      // padding: '0px' // no effect on top/bo, affect left/right
      //   height: '1vh' // positive
      height: '0.5em'
    },
    tableCellNoBoarder: {},
    tableCellTopLeft: {
      border: '1px solid black',
      verticalAlign: 'top',
      fontSize: '16px',
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.primary.main
    },
    disabledSigner: {
      //backgroundColor: '#dddddd'
      backgroundColor: theme.palette.grey[500],
      color: theme.palette.secondary.light
    },
    attachments: {
      marginTop: '5px' // move down a bit, didn't work//works, it wasn't because of a type - classesName
    },
    buttons: {
      marginLeft: 'auto', // make sure the button in cardActions align to the right
      maxWidth: '100%' // prevent button overflow it's parent -grid
    },
    textarea: {
      marginTop: '0px' // align textField input horizontally with grid content on it's left or right
    },
    // this is for timeoff application
    textField: {
      marginLeft: '20px',
      marginRight: '20px',
      width: 200
    },
    label: {
      cursor: 'pointer',
      paddingLeft: '0',
      color: 'rgba(0, 0, 0, 0.76)',
      fontSize: '1.2em',
      lineHeight: '1.428571429',
      fontWeight: '400',
      display: 'inline-flex',
      marginLeft: '15px'
    }
  }
}
export default requestSubContractPaymentStyle
